import DashboardHero from "../components/DashboardHero";
import AccountWidget from "../components/AccountWidget";
import RecentTransactions from "../components/RecentTransactions";
const Index = () => (
  <div className="flex flex-col px-2 pb-16 min-h-screen w-full bg-gradient-to-b from-background to-secondary via-background/80">
    <DashboardHero />
    <section className="w-full max-w-3xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-4 mt-6">
      <AccountWidget type="Checking" balance="$150,000.00" number="001245829" />
      <AccountWidget type="Savings" balance="$14,200.00" number="000384001" />
      <AccountWidget type="Credit" balance="$1,232.11" number="900285218" />
    </section>
    <div className="w-full max-w-3xl mx-auto">
      <RecentTransactions />
    </div>
  </div>
);

export default Index;